var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "029-hang-up 2",
    clipPath: "url(#clip0_110_10625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.6686 132.657V7.34262C35.6686 3.28945 38.958 0 43.0112 0H96.9888C101.042 0 104.331 3.28945 104.331 7.34262V132.657C104.331 136.71 101.042 140 96.9888 140H43.0112C38.958 140 35.6686 136.711 35.6686 132.657Z",
    fill: "url(#paint0_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M102.2 8.3418V131.659C102.2 135.041 99.4577 137.784 96.075 137.784H43.925C40.5424 137.784 37.8 135.041 37.8 131.659V8.3418C37.8 4.9591 40.5424 2.2168 43.925 2.2168H96.075C99.4577 2.2168 102.2 4.95883 102.2 8.3418Z",
    fill: "url(#paint1_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M97.1045 121.975H42.8955C41.7244 121.975 40.775 121.026 40.775 119.855V20.1459C40.775 18.9748 41.7244 18.0254 42.8955 18.0254H97.1048C98.2759 18.0254 99.2253 18.9748 99.2253 20.1459V119.855C99.225 121.026 98.2757 121.975 97.1045 121.975Z",
    fill: "url(#paint2_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.8332 13.6501H64.1665C63.0711 13.6501 62.1832 12.7622 62.1832 11.6668C62.1832 10.5714 63.0711 9.68359 64.1665 9.68359H75.8332C76.9286 9.68359 77.8165 10.5714 77.8165 11.6668C77.8167 12.7622 76.9289 13.6501 75.8332 13.6501Z",
    fill: "url(#paint3_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M102.2 131.658V129.709H37.8V131.658C37.8 135.041 40.5424 137.783 43.925 137.783H96.075C99.4577 137.783 102.2 135.041 102.2 131.658Z",
    fill: "url(#paint4_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M74.3305 125.638C73.2452 124.484 71.709 123.76 70 123.76C66.7139 123.76 64.05 126.424 64.05 129.71C64.05 131.419 64.7747 132.955 65.9283 134.04L71.889 140.001H88.6933L74.3305 125.638Z",
    fill: "url(#paint5_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70 135.66C73.2861 135.66 75.9501 132.996 75.9501 129.71C75.9501 126.424 73.2861 123.76 70 123.76C66.714 123.76 64.05 126.424 64.05 129.71C64.05 132.996 66.714 135.66 70 135.66Z",
    fill: "url(#paint6_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70 132.383C71.4764 132.383 72.6732 131.187 72.6732 129.71C72.6732 128.234 71.4764 127.037 70 127.037C68.5237 127.037 67.3269 128.234 67.3269 129.71C67.3269 131.187 68.5237 132.383 70 132.383Z",
    fill: "url(#paint7_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M56.3832 43.4357C52.9753 43.4357 50.9267 47.2157 52.7866 50.0712L66.4036 70.9736L99.2251 103.889V36.3856L81.3751 18.0254H58.6251V43.4357H56.3832Z",
    fill: "url(#paint8_linear_110_10625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.7863 50.0712L66.4033 70.9736C68.0964 73.5726 71.9029 73.5726 73.5963 70.9736L87.2132 50.0712C89.0734 47.2157 87.0246 43.4357 83.6167 43.4357H81.3751V18.0254H58.6251V43.4357H56.3831C52.9753 43.4357 50.9264 47.2159 52.7863 50.0712Z",
    fill: "#D63305"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11",
    filter: "url(#filter0_d_110_10625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 105.328C70.884 105.328 71.696 105.633 72.3337 106.143L69.9999 109L67.666 106.143C68.3037 105.633 69.1156 105.328 69.9999 105.328ZM58.6218 85L80.5026 106.639L78.7521 108.37L74.1952 103.864L73.8895 104.239C72.8266 103.389 71.4733 102.88 69.9999 102.88C68.5268 102.88 67.1741 103.388 66.1115 104.238L63.7783 101.381C65.3577 100.118 67.3377 99.3259 69.5002 99.2196L67.3055 97.0501C65.4112 97.4659 63.6802 98.311 62.2224 99.4769L59.8885 96.6206C61.211 95.5628 62.7064 94.7081 64.3263 94.1044L62.4307 92.2289C60.9527 92.8823 59.5769 93.7211 58.3336 94.7155L56 91.8589C57.1315 90.9539 58.3544 90.1564 59.6528 89.4818L56.8714 86.7311L58.6218 85ZM75.0553 97.8235L70.2678 93.0899L69.9999 93.087C73.8304 93.087 77.3483 94.4107 80.1114 96.6207L77.7779 99.4773C76.9514 98.8164 76.0372 98.2585 75.0553 97.8235ZM69.9999 86.9666C75.3035 86.9666 80.1742 88.7992 84 91.8591L81.6662 94.7155C78.4781 92.1659 74.4193 90.6388 69.9999 90.6388C69.2923 90.6388 68.5939 90.678 67.9068 90.7542L64.7078 87.5919C66.4041 87.1832 68.1763 86.9666 69.9999 86.9666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_110_10625",
    x: 52,
    y: 85,
    width: 36,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_10625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_10625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_10625",
    x1: 70.0022,
    y1: 238.003,
    x2: 70.0022,
    y2: 41.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_10625",
    x1: 70.0022,
    y1: -31.3424,
    x2: 70.0022,
    y2: 158.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_110_10625",
    x1: 70.0022,
    y1: 5.46048,
    x2: 70.0022,
    y2: 147.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_110_10625",
    x1: 70.0022,
    y1: 9.19974,
    x2: 70.0022,
    y2: 14.6141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_110_10625",
    x1: 70.0022,
    y1: 131.529,
    x2: 70.0022,
    y2: 145.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_110_10625",
    x1: 81.6077,
    y1: 141.313,
    x2: 56.5411,
    y2: 116.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_110_10625",
    x1: 67.1555,
    y1: 126.862,
    x2: 73.444,
    y2: 133.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_110_10625",
    x1: 72.04,
    y1: 131.749,
    x2: 69.2165,
    y2: 128.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_110_10625",
    x1: 106.407,
    y1: 67.2112,
    x2: 69.7723,
    y2: 52.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6A6A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_10625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no_internet.69cb02cbdbe9646bb8fb216c109b16df.svg";
export { ForwardRef as ReactComponent };